import moment from 'moment';

export const calculateReadingValues = (meter) => {
  const isUtilityPortal = meter.dataSource === 'utility-portal';
  const isCalculatedFromValue =
    meter.dataSource === 'meter' || meter.dataSource === '' || !meter.dataSource;

  meter.readings.sort((a, b) => moment(a.time) - moment(b.time));

  if (isUtilityPortal) {
    let runningValue = 0;
    for (let i = 0; i < meter.readings.length; i++) {
      const r = meter.readings[i];
      if (r.deleted) continue;
      const daily = Number.isFinite(Number(r.dailyUsage)) ? Number(r.dailyUsage) : 0;
      r.rawUsage = daily;
      runningValue += daily;
      r.value = runningValue;
    }
    return meter;
  }

  let firstReadingAccountedFor = false;
  let previousNonDeletedReading = 0;

  if (isCalculatedFromValue) {
    for (let i = 0; i < meter.readings.length; i++) {
      if (meter.readings[i].deleted) {
        continue;
      } // skip if reading deleted
      if (!firstReadingAccountedFor) {
        meter.readings[i].rawUsage = meter.readings[i].value;
        meter.readings[i].dailyUsage = NaN;
        firstReadingAccountedFor = true;
        previousNonDeletedReading = i;
        continue;
      }
      let valueDiff = meter.readings[i].value - meter.readings[previousNonDeletedReading].value;
      let timeDiff = moment(meter.readings[i].time) - moment(meter.readings[previousNonDeletedReading].time);
      meter.readings[i].rawUsage = valueDiff;
      meter.readings[i].dailyUsage = (valueDiff / timeDiff) * 1000 * 60 * 60 * 24;
      previousNonDeletedReading = i;
    }
  } else {
    for (let i = 0; i < meter.readings.length; i++) {
      if (meter.readings[i].deleted) {
        continue;
      } // skip if reading deleted
      if (!firstReadingAccountedFor) {
        meter.readings[i].value = meter.readings[i].rawUsage;
        firstReadingAccountedFor = true;
        previousNonDeletedReading = i;
        continue;
      }
      meter.readings[i].value = meter.readings[previousNonDeletedReading].value + meter.readings[i].rawUsage;
      let timeDiff = moment(meter.readings[i].time) - moment(meter.readings[previousNonDeletedReading].time);
      meter.readings[i].dailyUsage = (meter.readings[i].rawUsage / timeDiff) * 1000 * 60 * 60 * 24;
      previousNonDeletedReading = i;
    }
  }

  if (isCalculatedFromValue) {

  }
  return meter;
}
